module.exports = __webpack_public_path__ + "static/media/Pet Adoption App Icon.c383cfbe.png";